import { Zap, Github, ExternalLink } from "lucide-react";
import { AppStoreBadge } from "./AppStoreBadge";
import { GooglePlayBadge } from "./GooglePlayBadge";
import { WEB_POS_DEMO_URL } from "@/lib/links";

export const Footer = ({ t, lang }) => (
  <footer data-testid="site-footer" className="bg-[#050505] border-t border-white/10 py-14">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col md:flex-row md:items-start justify-between gap-10">
      <div className="max-w-sm">
        <div className="flex items-center gap-2 font-heading font-bold text-white mb-3">
          <span className="w-7 h-7 rounded-lg bg-[#F7931A] flex items-center justify-center">
            <Zap className="w-3.5 h-3.5 text-black" fill="currentColor" />
          </span>
          Lightning POS
        </div>
        <p className="text-sm text-zinc-500 leading-relaxed">{t.footer.tagline}</p>
        <div className="mt-6 flex flex-wrap items-center gap-3">
          <AppStoreBadge t={t} lang={lang} className="h-11" testId="footer-app-store-badge" />
          <GooglePlayBadge t={t} lang={lang} className="h-11" testId="footer-google-play-badge" />
        </div>
      </div>
      <div>
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500 mb-4">{t.footer.links}</p>
        <div className="flex flex-col gap-3 text-sm">
          <a href={WEB_POS_DEMO_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-demo-link"
            className="inline-flex items-center gap-2 text-zinc-400 hover:text-white transition-colors">
            <ExternalLink className="w-4 h-4" /> {t.footer.demo}
          </a>
          <a href="https://github.com/fernando-mendoza" target="_blank" rel="noopener noreferrer" data-testid="footer-github-link"
            className="inline-flex items-center gap-2 text-zinc-400 hover:text-white transition-colors">
            <Github className="w-4 h-4" /> GitHub
          </a>
        </div>
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-6 lg:px-8 mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-zinc-600">
      <span>© {new Date().getFullYear()} Lightning POS. {t.footer.rights}</span>
      <a
        href="https://agentyk.co"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="footer-agentyk-brand"
        className="inline-flex items-center gap-1 text-zinc-500 hover:text-white transition-colors"
      >
        Made with <span className="text-red-500">❤</span> by AgentykCo™
      </a>
    </div>
  </footer>
);
